export default __webpack_public_path__ + "static/media/data-il.452c939c.svg";